<template>
	<div class="contenedor">
		<!--<CarouselGira :redirect="true"></CarouselGira> -->
		<FiltroBusqueda v-if="
			currentRoute != '/login' &&
			currentRoute != '/registro' &&
			currentRoute != '/passwordReset'
		">
		</FiltroBusqueda>

		<Carousel class="mb-0 pb-0" :eventos="imagenesEventoCarousel" :redirect="true"></Carousel>


		<Eventos class="order-2 order-md-1" :eventos="eventos" :precioInicio="rangoPrecio[0]" :precioFin="rangoPrecio[1]"
			:artistasFilter="artistasFilter" :tiposEventosFilter="tiposEventosFilter" :fechaInicio="desde"
			:fechaFin="hasta" :ciudadeseventosFilter="ciudadeseventosFilter">
		</Eventos>

		<Destacados class="order-1 order-md-2" :eventos="eventos" :redirect="true">
		</Destacados>

		<Servicios class="order-3 order-md-3"></Servicios>
		<div v-if="imagenesEventoCarousel.length < 0">
			<div class="d-flex flex-wrap">
				<div class="col-12 d-flex flex-wrap skeleton-imgs-principales p-0">
					<div class="col-12 col-md-6 py-0 pl-0" style="aspect-ratio: 2/1">
						<v-skeleton-loader type="image"></v-skeleton-loader>
					</div>
					<div class="col-12 col-md-6 py-0 pr-0" style="aspect-ratio: 2/1">
						<v-skeleton-loader type="image"></v-skeleton-loader>
					</div>
				</div>
				<div class="col-12 col-md-8 col-xl-9">
					<div class="skeleton-banner-principal col-12 p-0">
						<v-skeleton-loader type="image"></v-skeleton-loader>
					</div>
					<div class="skeleton-carousel-under-banner col-12 p-0">
						<div class="col-12 col-md-4" style="aspect-ratio: 5/6">
							<v-skeleton-loader type="image"></v-skeleton-loader>
						</div>
						<div class="col-12 col-md-4" style="aspect-ratio: 5/6">
							<v-skeleton-loader type="image"></v-skeleton-loader>
						</div>
						<div class="col-12 col-md-4" style="aspect-ratio: 5/6">
							<v-skeleton-loader type="image"></v-skeleton-loader>
						</div>
					</div>
				</div>
				<div class="skeleton-fb col-sm-12 col-md-4 col-xl-3">
					<v-skeleton-loader type="image"></v-skeleton-loader>
				</div>
			</div>
		</div>
		<div class="btn-help-container slide-bck-top-normal">
			<a href="https://centrodeayuda.ticketshop.com.co" atl="Peticiones, Quejas y Reclamos">
			  <v-tooltip left>
				 <template v-slot:activator="{ on, attrs }">
					<v-btn class="btn-help"
							 fab
							 large
							 dark
							 color="tertiary"
							 v-bind="attrs"
							 v-on="on">
					  <v-icon large>mdi-face-agent</v-icon>
					</v-btn>
				 </template>
				 <span>Ayuda</span>
			  </v-tooltip>
			</a>
		 </div>		 
	</div>
</template>
<script>
import moment from "moment";

moment.locale("es");
import axios from "axios";

import { configApi } from "../api/configApi";
import { headers } from "../api/headers";
import Carousel from "./fragments/Carousel.vue";
import CarouselGira from "./fragments/Gira.vue";
import TipoEventos from "./fragments/TipoEventos.vue";
import Eventos from "./utils/Eventos.vue";
import Destacados from "./fragments/Destacados.vue";
import FiltroBusqueda from "./fragments/FiltroBusqueda.vue";
import Servicios from "./fragments/Servicios.vue";

export default {
	components: {
		Carousel,
		CarouselGira,
		TipoEventos,
		Eventos,
		Destacados,
		FiltroBusqueda,
		Servicios,
	},
	async beforeCreate() {
		this.$store.dispatch("tipoevento/listTipoEvento", 1);
		this.$store.dispatch("artista/listArtistasActive", 1);
		this.$store.dispatch("evento/listEventosEstadoBanner");
		this.$store.dispatch("evento/bannersDestacados");
	},
	async created() {
		document.title = "Inicio - TicketShop";
		await axios
			.get(`${configApi.apiUrl}banner_gira`, null, {
				headers: headers,
			})
			.then((response) => {
				this.ciudadeseventos = response.data.vciudadEventos.map(
					(item) => ({
						id: item.id,
						descripcion: item.descripcion,
					})
				);
			});
	},
	mounted() {
		this.setWidthDivFacebook();
		setTimeout(() => {
			//let heightFace = this.$refs.prinCartel.clientHeight;
			//let widthFace = this.$refs.faceCartel.clientWidth;
			//this.$refs.blockFace.dataset.height=heightFace;
			//this.$refs.blockFace.dataset.width=widthFace;
		}, 1000);
		setTimeout(() => {
			this.showSelectsFilter = true;
		}, 500);
		this.listAllEventos();
		//   let heightFace = this.$refs.prinCartel.clientHeight;
		//   let widthFace = this.$refs.faceCartel.clientWidth;
		//   this.$refs.blockFace.dataset.height=heightFace;
		//   this.$refs.blockFace.dataset.width=widthFace;
		// document.getElementById('div-facebook-page').innerHTML = `
		//   <div class="fb-page" data-href="https://www.facebook.com/TICKETSHOPCOL" data-tabs="timeline" data-width="500" data-height="600" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
		//     <blockquote cite="https://www.facebook.com/TICKETSHOPCOL" class="fb-xfbml-parse-ignore">
		//       <a href="https://www.facebook.com/TICKETSHOPCOL">Ticket Shop Colombia</a>
		//     </blockquote>
		//   </div>
		// `
		//}, 15000);
	},
	data() {
		return {
			ordenarEventosSelect: ["Precio boleta"],
			desde: null,
			hasta: null,
			menu: false,
			modal: false,
			modal2: false,
			menu2: false,
			precioInicial: 1000,
			precioFinal: 10000000,
			rangoPrecio: [10000, 15000000],
			btnAccesibilidad: false,
			artistasFilter: [],
			tiposEventosFilter: [],
			ciudadeseventos: [],
			ciudadeseventosFilter: [],
			showSelectsFilter: false,
			widthDivFacebook: 500,
			heightDivFacebook: 600,
			currentRoute: window.location.pathname,
		};
	},
	watch: {
		$route(to, from) {
			this.currentRoute = window.location.pathname;
		},
	},
	computed: {
		eventos() {
			return this.$store.getters["evento/listEventos"].reverse();
		},
		eventosDestacados() {
			return this.showEventosDestacados.reverse().slice(0, 3);
		},
		showEventosDestacados() {
			return this.$store.getters["evento/listEventos"];
		},
		tiposEventos() {
			return this.$store.getters["tipoevento/listTipoEvento"];
		},
		artistas() {
			return this.$store.getters["artista/listArtistas"];
		},
		eventosEstadoBanner() {
			return this.$store.getters["evento/listEventosEstadoBanner"];
		},
		imagenesEventoCarousel() {
			var imagenesEventoCarouselShow = [];
			for (var i = 0; i < this.eventosEstadoBanner.length; i++) {
				var evento = this.eventosEstadoBanner[i];
				var imagenEncontrada = false;
				for (var j = 0; j < evento.imagens.length && !imagenEncontrada; j++) {
					if (evento.imagens[j].nombre.includes("banner_x")) {
						imagenesEventoCarouselShow.push({
							imagen: evento,
							url: evento.imagens[j].url
						});
						imagenEncontrada = true;
					}
				}
			}

			// Reordenar al azar
			var currentIndex = imagenesEventoCarouselShow.length,
				temporaryValue,
				randomIndex;

			// Mientras queden elementos por barajar...
			while (0 !== currentIndex) {
				// Seleccionar un elemento restante...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;

				// E intercambiarlo con el elemento actual.
				temporaryValue = imagenesEventoCarouselShow[currentIndex];
				imagenesEventoCarouselShow[currentIndex] =
					imagenesEventoCarouselShow[randomIndex];
				imagenesEventoCarouselShow[randomIndex] = temporaryValue;
			}

			return imagenesEventoCarouselShow;
		},

		/*srcIframeFacebook() {
	let divFacebook = document.getElementById("div-facebook-page");
	if (divFacebook) {
	  this.widthDivFacebook = divFacebook.clientWidth;
	  this.heightDivFacebook = divFacebook.clientHeight;
	  if (window.innerWidth < 768) {
		 this.widthDivFacebook = window.innerWidth;
	  }
	} else {
	  this.setWidthDivFacebook();
	}
	return `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FTICKETSHOPCOL%2F&tabs=timeline&width=${this.widthDivFacebook
	  }&height=${this.heightDivFacebook < 600 ? 600 : this.heightDivFacebook * 2
	  }&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=2235597906716847`;
 },*/
	},
	methods: {
		formatFecha(fecha) {
			if (fecha != null && fecha != "") {
				return moment(fecha).format("MMMM, DD YYYY");
			} else {
				return "";
			}
		},
		formatNumber(number) {
			return new Intl.NumberFormat("es-CO", {
				style: "currency",
				currency: "COP",
				minimumFractionDigits: 0,
			}).format(number);
		},
		filterEventos() {
			this.$store.dispatch("evento/filterEventos", {
				page: 1,
				precio_inicio: this.rangoPrecio[0],
				precio_fin: this.rangoPrecio[1],
				artistas: this.artistasFilter,
				tiposEvento: this.tiposEventosFilter,
				fecha_inicio: this.desde,
				fecha_fin: this.hasta,
				ciudadeseventos: this.ciudadeseventosFilter,
			});
		},
		listAllEventos() {
			this.$store.dispatch("evento/filterEventos", {
				precio_inicio: this.rangoPrecio[0],
				precio_fin: this.rangoPrecio[1],
				artistas: this.artistasFilter,
				tipos_evento: this.tiposEventosFilter,
				fecha_inicio: this.desde,
				fecha_fin: this.hasta,
			});
		},
		setWidthDivFacebook() {
			let divFacebook = document.getElementById("div-facebook-page");
			if (!divFacebook) {
				return setTimeout(() => this.setWidthDivFacebook(), 1000);
			}
			this.widthDivFacebook = divFacebook.clientWidth;
			this.heightDivFacebook = divFacebook.clientHeight;
		},
	},
};
</script>
<style>
.cont-evento {
	background-color: white;
	border: 1px gray solid;
	text-align: right;
	aspect-ratio: 5/6;
	width: 100%;
	margin-top: 40px;
}

.cont-fecha-activo {
	background-color: green;
	position: relative;
	right: -12px;
	padding: 4px 9px;
	color: white;
	border-radius: 3px;
	box-shadow: -1px 3px 4px 0px #000000;
}

.cont-fecha-aplazado {
	background-color: #ffff00;
	position: relative;
	right: -12px;
	padding: 4px 9px;
	color: #000000;
	border-radius: 3px;
	box-shadow: -1px 3px 4px 0px #000000;
}

.proximamente-img {
	max-width: 100%;
	width: 100%;
}

.searchEventos .v-input__slot {
	border-radius: 30px !important;
}

.label-text-ordenar-eventos {
	margin-top: 10px;
}

label {
	margin-bottom: 0 !important;
}

.btn-help-container {
	position: fixed;
	bottom: 16px;
	right: 16px;
	perspective: 800px; 
 }
 
 
 .slide-bck-top-normal { 
	  animation: slide-bck-top-normal 0.45s cubic-bezier(0.470, 0.000, 0.745, 0.715) 0s 1 normal both; 
 }
 
 @keyframes slide-bck-top {
	0% { 
	  transform: translateZ(0) translateY(0); 
	} 
	100% { 
	  transform: translateZ(-400px) translateY(-50px);
	}
 }
 
 
 .slide-bck-top-normal { 
	  animation: slide-bck-top 0.45s cubic-bezier(0.470, 0.000, 0.745, 0.715) 0s 1 normal both; 
 }
 
 
 .v-btn.btn-help {
	animation: wiggle 2s linear infinite 4s;
 }
 
 @keyframes wiggle {
	0%, 7% {
	  transform: rotateZ(0);
	}
	15% {
	  transform: rotateZ(-25deg);
	}
	20% {
	  transform: rotateZ(10deg);
	}
	25% {
	  transform: rotateZ(-10deg);
	}
	30% {
	  transform: rotateZ(6deg);
	}
	35% {
	  transform: rotateZ(-4deg);
	}
	40%, 100% {
	  transform: rotateZ(0);
	}
 }
</style>

<style scoped>
/* .eventos-principales {
  display: flex;
  padding: var(--Espaciado-xl, 48px) 160px;
  flex-direction: column;
  align-items: center;
  gap: 56px;
} */

.fondo-background {
	background: var(--Gray-1000, #000000);
}



 

 
</style>
